"use client";

import type { CSSProperties, ReactNode } from "react";
import { usePathname } from "next/navigation";
import AppTopbar from "@/components/common/AppTopbar";
import GailDockLayout from "./dock/GailDockLayout";
import GailGptLauncher from "./GailGptLauncher";

/** Dedicated chat and workflow editors use the entire content area. */
export default function GailAppLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname() ?? "";
  const isChatPage = pathname === "/gailgpt" || pathname.startsWith("/gailgpt/");
  const isWorkflowBuilder = /^\/workflows\/[^/]+\/builder(?:\/|$)/.test(pathname);
  const showTopbar = !isChatPage && !isWorkflowBuilder;

  return (
    <div
      className="min-w-0"
      style={{
        "--app-topbar-height": showTopbar ? "56px" : "0px",
        "--page-padding-top": "28px",
        "--page-padding-x": "72px",
      } as CSSProperties}
    >
      {showTopbar && <AppTopbar><GailGptLauncher placement="topbar" /></AppTopbar>}
      <GailDockLayout>{children}</GailDockLayout>
    </div>
  );
}
